module.exports = __webpack_public_path__ + "media/src/assets/images/circle-cd7772324992b12682202bd22beb9822.svg";